import React from 'react';
import styled from 'styled-components';
import {SlaAchievementGauge} from './SlaAchievementGauge';
import {TicketTrendChart} from './TicketTrendChart';
import type {SlaGaugeData} from './SlaAchievementGauge';
import type {TrendPoint} from './TicketTrendChart';

interface Props {
	gauge: SlaGaugeData;
	trend: TrendPoint[];
}

const Row = styled.div`
	display: flex;
	flex-direction: row;
	gap: 24px;
	align-items: stretch;
`;

// Same card chrome as the shared EmptyState's `card` variant
// (features/tickets/components/EmptyState.tsx) — a bordered neutral surface. There is
// no `sys.color.surface.*` in the design system; a card's fill is
// `background.neutral['1']`.
const CardBase = styled.div`
	border: ${p => p.theme.sys.size.borderwidth.thin} solid ${p => p.theme.sys.color.border.decorative};
	border-radius: ${p => p.theme.sys.size.borderradius['3']};
	padding: ${p => p.theme.sys.spacing['600']};
	background: ${p => p.theme.sys.color.background.neutral['1']};
	display: flex;
	flex-direction: column;
`;

const GaugeCard = styled(CardBase)`
	width: 360px;
	flex-shrink: 0;
`;

const TrendCard = styled(CardBase)`
	flex: 1;
	min-width: 0;
`;

const CardTitle = styled.h2`
	${p => p.theme.sys.font?.subheading?.['1']}
	color: ${p => p.theme.sys.color.text.content.main};
	margin: 0 0 16px;
`;

export function DashboardVisualizationRow({gauge, trend}: Props) {
	return (
		<Row>
			<GaugeCard>
				<CardTitle>SLA Achievement Rate</CardTitle>
				<SlaAchievementGauge gauge={gauge} />
			</GaugeCard>
			<TrendCard>
				<CardTitle>Tickets created vs resolved</CardTitle>
				<TicketTrendChart trend={trend} />
			</TrendCard>
		</Row>
	);
}
